import { PERMISSIONS } from "./permissionKeys.js";

export const Permissions = {
    [PERMISSIONS.FILTER_PROVIDER]: {
      roles: ['admindsas']
    },
  
    [PERMISSIONS.AREA_THIRDPARTY]: {
      roles: ['admindsas']
    },

    // COMPETITION

    [PERMISSIONS.SPORT_COMPETITION_HOME_PAGE]: {
        roles: ['admin', 'admindsas', 'write', 'read']
    },

    [PERMISSIONS.SPORT_COMPETITION_CREATE_PAGE]: {
        roles: ['admin', 'admindsas']
    },

    [PERMISSIONS.SPORT_COMPETITION_EDIT_PAGE]: {
      roles: ['admin', 'admindsas', 'write']
    },
  
    [PERMISSIONS.SPORT_COMPETITION_HOME_BUTTON_CREATE]: {
      roles: ['admin', 'admindsas'],
      disabledOnly: true
    },
  
    [PERMISSIONS.SPORT_COMPETITION_HOME_BUTTON_EDIT]: {
      roles: ['write', 'admin', 'admindsas'],
      disabledOnly: true
    },
  
    [PERMISSIONS.SPORT_COMPETITION_HOME_BUTTON_DELETE]: {
      roles: ['admin', 'admindsas'],
      disabledOnly: true
    },

    [PERMISSIONS.SPORT_COMPETITION_HOME_BUTTON_EXPORT]: {
      roles: ['admin', 'admindsas'],
      disabledOnly: true
    },
  
    [PERMISSIONS.SPORT_COMPETITION_HOME_BUTTON_MULTIEDIT]: {
      roles: ['admindsas'],
    },
  
    [PERMISSIONS.SPORT_COMPETITION_CREATE_AREA_VISIBLEAPI]: {
      roles: ['admindsas']
    },
  
    [PERMISSIONS.SPORT_COMPETITION_CREATE_INPUT_NBDAYS]: {
      roles: ['admin', 'admindsas'],
      disabledOnly: true
    },
  
    [PERMISSIONS.SPORT_COMPETITION_CREATE_INPUT_NBTEAMS]: {
      roles: ['admin', 'admindsas'],
      disabledOnly: true
    },
  
    [PERMISSIONS.SPORT_COMPETITION_CREATE_BUTTON_DELETE]: {
      roles: ['admin', 'admindsas'],
      disabledOnly: true
    },
    [PERMISSIONS.SPORT_COMPETITION_HOME_BUTTON_PROFILE]: {
      roles: ['admin', 'admindsas'],
      disabledOnly: true
    },

    [PERMISSIONS.SPORT_COMPETITION_PROVIDER_NAME_DISPLAY]: {
      roles: ['admin', 'admindsas'],
    },

    // TEAM

    [PERMISSIONS.SPORT_TEAM_HOME_PAGE]: {
      roles: ['admin', 'admindsas', 'write', 'read'],
    },

    [PERMISSIONS.SPORT_TEAM_CREATE_PAGE]: {
      roles: ['admin', 'admindsas'],
    },

    [PERMISSIONS.SPORT_TEAM_EDIT_PAGE]: {
      roles: ['admin', 'admindsas', 'write'],
    },

    [PERMISSIONS.SPORT_TEAM_MULTIEDIT_PAGE]: {
      roles: ['admindsas'],
    },

    [PERMISSIONS.SPORT_TEAM_HOME_BUTTON_CREATE]: {
      roles: ['admin', 'admindsas'],
      disabledOnly: true
    },

    [PERMISSIONS.SPORT_TEAM_HOME_BUTTON_EDIT]: {
      roles: ['admin', 'admindsas', 'write'],
      disabledOnly: true
    },

    [PERMISSIONS.SPORT_TEAM_HOME_BUTTON_DELETE]: {
      roles: ['admin', 'admindsas'],
      disabledOnly: true
    },

    [PERMISSIONS.SPORT_TEAM_HOME_BUTTON_EXPORT]: {
      roles: ['admin', 'admindsas'],
      disabledOnly: true
    },

    [PERMISSIONS.SPORT_TEAM_HOME_BUTTON_MULTIEDIT]: {
      roles: ['admindsas'],
    },

    [PERMISSIONS.SPORT_TEAM_HOME_BUTTON_EXPORTCSV]: {
      roles: ['admin', 'admindsas'],
      disabledOnly: true
    },

    [PERMISSIONS.SPORT_TEAM_HOME_BUTTON_PROFILE]: {
      roles: ['admin', 'admindsas'],
      disabledOnly: true
    },

    [PERMISSIONS.SPORT_TEAM_CREATE_BUTTON_REMOVEPENALITY]: {
      roles: ['admin', 'admindsas'],
      disabledOnly: true
    },

    [PERMISSIONS.SPORT_TEAM_CREATE_BUTTON_DIRECTTYPE]: {
      roles: ['admindsas'],
    },

    [PERMISSIONS.SPORT_TEAM_CREATE_BUTTON_DELETE]: {
      roles: ['admin', 'admindsas'],
      disabledOnly: true
    },

    [PERMISSIONS.SPORT_TEAM_PROVIDER_NAME_DISPLAY]: {
      roles: ['admin', 'admindsas'],
    },

    // PLAYER
    [PERMISSIONS.SPORT_PLAYER_HOME_PAGE]: {
      roles: ['admin', 'admindsas', 'write', 'read'],
    },

    [PERMISSIONS.SPORT_PLAYER_FUSION_PAGE]: {
      roles: ['admin', 'admindsas', 'write'],
    },

    [PERMISSIONS.SPORT_PLAYER_CREATE_PAGE]: {
      roles: ['admin', 'admindsas', 'write'],
    },

    [PERMISSIONS.SPORT_PLAYER_EDIT_PAGE]: {
      roles: ['admin', 'admindsas', 'write'],
    },

    [PERMISSIONS.SPORT_PLAYER_MULTIEDIT_PAGE]: {
      roles: ['admindsas'],
    },

    [PERMISSIONS.SPORT_PLAYER_HOME_BUTTON_CREATE]: {
      roles: ['admin', 'admindsas', 'write'],
      disabledOnly: true
    },

    [PERMISSIONS.SPORT_PLAYER_HOME_BUTTON_EDIT]: {
      roles: ['admin', 'admindsas', 'write'],
      disabledOnly: true
    },

    [PERMISSIONS.SPORT_PLAYER_PROVIDER_NAME_DISPLAY]: {
      roles: ['admin', 'admindsas'],
    },

    [PERMISSIONS.SPORT_PLAYER_HOME_BUTTON_DELETE]: {
      roles: ['admin', 'admindsas'],
      disabledOnly: true
    },

    [PERMISSIONS.SPORT_PLAYER_HOME_BUTTON_EXPORT]: {
      roles: ['admin', 'admindsas'],
      disabledOnly: true
    },

    [PERMISSIONS.SPORT_PLAYER_HOME_BUTTON_MULTIEDIT]: {
      roles: ['admindsas'],
    },

    [PERMISSIONS.SPORT_PLAYER_HOME_BUTTON_EXPORTCSV]: {
      roles: ['admindsas', 'admin'],
      disabledOnly: true
    },

    [PERMISSIONS.SPORT_PLAYER_HOME_BUTTON_PROFILE]: {
      roles: ['admindsas', 'admin'],
      disabledOnly: true
    },

    [PERMISSIONS.SPORT_PLAYER_HOME_BUTTON_FUSION]: {
      roles: ['admindsas', 'admin', 'write'],
      disabledOnly: true
    },

    [PERMISSIONS.SPORT_PLAYER_CREATE_BUTTON_REMOVETRANSFERT]: {
      roles: ['admindsas', 'admin'],
      disabledOnly: true
    },

    [PERMISSIONS.SPORT_PLAYER_CREATE_BUTTON_DELETE]: {
      roles: ['admindsas', 'admin'],
      disabledOnly: true
    },


    // CALENDAR
    [PERMISSIONS.SPORT_CALENDAR_HOME_PAGE]: {
      roles: ['admin', 'admindsas', 'write', 'read'],
    },
    [PERMISSIONS.SPORT_CALENDAR_HOME_INPUT_DAY]: {
      roles: ['admin', 'admindsas'],
      disabledOnly: true
    },
    [PERMISSIONS.SPORT_CALENDAR_HOME_INPUT_DATE]: {
      roles: ['admin', 'admindsas', 'write'],
      disabledOnly: true
    },
    [PERMISSIONS.SPORT_CALENDAR_HOME_INPUT_TEAM]: {
      roles: ['admin', 'admindsas'],
      disabledOnly: true
    },
    [PERMISSIONS.SPORT_CALENDAR_HOME_EDIT_THIRDPARTY]: {
      roles: ['admindsas'],
    }, 
    [PERMISSIONS.SPORT_CALENDAR_HOME_BUTTON_EXPORTCSV]: {
      roles: ['admindsas', 'admin'],
      disabledOnly: true
    },

    // LIVES
    [PERMISSIONS.SPORT_LIVES_HOME_PAGE]: {
      roles: ['admin', 'admindsas', 'write', 'read'],
    },
    [PERMISSIONS.SPORT_LIVES_HOME_BUTTON_CREATE]: {
      roles: ['admin', 'admindsas'],
      disabledOnly: true
    },
    [PERMISSIONS.SPORT_LIVES_HOME_BUTTON_EDIT]: {
      roles: ['admin', 'admindsas', 'write'],
      disabledOnly: true
    },
    [PERMISSIONS.SPORT_LIVES_HOME_BUTTON_DELETE]: {
      roles: ['admin', 'admindsas'],
      disabledOnly: true
    },

    // LIVES
    [PERMISSIONS.DIVERS_LIVES_HOME_PAGE]: {
      roles: ['admin', 'admindsas', 'write', 'read'],
    },
    [PERMISSIONS.DIVERS_LIVES_HOME_BUTTON_CREATE]: {
      roles: ['admin', 'admindsas', 'write'],
      disabledOnly: true
    },
    [PERMISSIONS.DIVERS_LIVES_HOME_BUTTON_EDIT]: {
      roles: ['admin', 'admindsas', 'write'],
      disabledOnly: true
    },
    [PERMISSIONS.DIVERS_LIVES_HOME_BUTTON_DELETE]: {
      roles: ['admin', 'admindsas'],
      disabledOnly: true
    },
    [PERMISSIONS.DIVERS_LIVES_HOME_NAME_EDIT]: {
      roles: ['admin', 'admindsas', 'write'],
      disabledOnly: false
    },
    [PERMISSIONS.DIVERS_LIVES_HOME_DAYSTATS_DISPLAY]: {
      roles: ['admindsas'],
      disabledOnly: false
    },

    // LIVE
    [PERMISSIONS.SPORT_LIVE_HOME_PAGE]: {
      roles: ['admin', 'admindsas', 'write', 'read'],
    },

    // RESULT
    [PERMISSIONS.SPORT_RESULT_HOME_PAGE]: {
      roles: ['admindsas'],
    },

    // MATCH
    [PERMISSIONS.SPORT_MATCH_HOME_PAGE]: {
      roles: ['admindsas'],
    },

    // MATCH MANAGEMENT
    [PERMISSIONS.SPORT_MATCHMANAGEMENT_HOME_PAGE]: {
      roles: ['admindsas'],
    },

    // ADMIN
    [PERMISSIONS.SPORT_ADMIN_HOME_PAGE]: {
      roles: ['admindsas'],
    },

  };